module.exports = __webpack_public_path__ + "static/media/logo-vermelha.06579ca7.svg";